import type { Editor } from "@tiptap/react";
import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { Modal } from "@circle-react-uikit/ModalV2";
import { VoiceMessageRecorder } from "./VoiceMessageRecorder";

interface VoiceMessageModalProps {
  addToLocalInlineAttachments?: (args: any) => void;
  editor: Editor;
  range: { from: number; to: number };
}

export const VoiceMessageModalComponent = ({
  editor,
  range,
  addToLocalInlineAttachments = noop,
}: VoiceMessageModalProps) => {
  const modal = useModal();

  return (
    <Modal isOpen={modal.visible} onClose={modal.remove}>
      <Modal.Overlay />
      <Modal.Content size="md">
        <Modal.Header>
          <Modal.Title size="sm">
            {t("tiptap.voice_message.action")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <VoiceMessageRecorder
            onClose={modal.remove}
            addToLocalInlineAttachments={addToLocalInlineAttachments}
            editor={editor}
            range={range}
          />
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};

const VoiceMessageModal = ModalManager.create(
  ({ editor, range, addToLocalInlineAttachments }: VoiceMessageModalProps) => (
    <VoiceMessageModalComponent
      editor={editor}
      range={range}
      addToLocalInlineAttachments={addToLocalInlineAttachments}
    />
  ),
);

export const useVoiceMessageModal = () => useModal(VoiceMessageModal);
